import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWindowRestore } from '@fortawesome/free-solid-svg-icons'
import React from 'react'
import styled from 'styled-components'
import '../../../../../javascript/i18n'

export type StyledJobOffersSeoContentProps = {
  title: string;
  mainDescription?: string;
  aboutCategory?: string;
  aboutSkill?: Array<{
    title: string;
    description: string;
  }>;
  requiredSkill?: string;
  relatedArticles?: Array<RelatedArticles>;
}

type RelatedArticles = {
  title: string;
  url: string;
}

const StyledContainer = styled.div`
  border-top: 1px solid ${props => props.theme.members.colors.silver._30};
  padding: 40px 16px;

  @media ${props => props.theme.media.md} {
    padding: 40px 0;
  }
`

const StyledTitle = styled.div`
  font-family: Noto Sans JP;
  font-size: 20px;
  font-weight: 700;
  line-height: 34px;
  text-align: left;
  margin-bottom: 16px;
`

const StyledArticleContainer = styled.div`
  margin-bottom: 32px;
`

const StyledArticleTitle = styled.div`
  font-family: Noto Sans JP;
  font-size: 14px;
  font-weight: 700;
  line-height: 23.8px;
  text-align: left;
  padding-bottom: 8px;
`

const StyledDescriptionText = styled.div`
  font-family: Noto Sans JP;
  font-size: 12px;
  font-weight: 400;
  line-height: 20.4px;
  text-align: left;
`

const StyledRelatedArticleLink = styled.a`
  font-family: Noto Sans JP;
  font-size: 12px;
  font-weight: 700;
  line-height: 20.4px;
  text-align: left;
  color: ${props => props.theme.members.colors.appleGreen._90};
`

export const StyledJobOffersSeoContent: React.FC<StyledJobOffersSeoContentProps> = (props: StyledJobOffersSeoContentProps) => {
  return (
    <StyledContainer>
      <StyledTitle>{props.title}</StyledTitle>
      <StyledDescriptionText>{props.mainDescription}</StyledDescriptionText>
      {props.aboutCategory && <StyledArticleContainer><StyledDescriptionText>{props.aboutCategory}</StyledDescriptionText></StyledArticleContainer>}
      {props.aboutSkill && (
        <>
          {props.aboutSkill.map((skill, index) => (
            <StyledArticleContainer key={index}>
              <StyledArticleTitle>{skill.title}</StyledArticleTitle>
              <StyledDescriptionText>{skill.description}</StyledDescriptionText>
            </StyledArticleContainer>
          ))}
        </>
      )}
      {props.requiredSkill && (
        <StyledArticleContainer>
          <StyledArticleTitle>必要なスキル</StyledArticleTitle>
          <StyledDescriptionText>{props.requiredSkill}</StyledDescriptionText>
        </StyledArticleContainer>
      )}
      {props.relatedArticles && (
        <StyledArticleContainer>
          <StyledArticleTitle>よく読まれている関連記事</StyledArticleTitle>
          {props.relatedArticles.map((article, index) => (
            <div key={index}>
              <StyledRelatedArticleLink href={article.url}>{article.title} <FontAwesomeIcon icon={faWindowRestore} style={{ color: '#0BBE78' }} /></StyledRelatedArticleLink>
            </div>
          ))}
        </StyledArticleContainer>
      )}
    </StyledContainer>
  )
}
